//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HairBanner',
  props: {
    titleId: {
      type: String,
      default: 'hair'
    }
  },
  data: () => ({
    hairList: [],
    hairKey: false,
    message: '',
    gender: '',
    age: '',
    phone: '',
    ableToCome: '',
    phoneValidated: false,
    options: {
      loop: false,
      lazy: true,
      slidesPerView: 1,
      allowTouchMove: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.next-hair',
        prevEl: '.prev-hair',
      }

    },

  }),
  computed: {
    phoneValidatedComputed() {
      return this.phoneValidated;
    },
    swiperOptions() {
      return this.options = {
        ...this.options,
        navigation: {
          nextEl: '.next-hair-' + this.titleId,
          prevEl: '.prev-' + this.titleId,
        }
      }
    }
  },
  mounted() {
    const nextButtons = document.querySelectorAll('.update-message-' + this.titleId);

    nextButtons.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const value = item.getAttribute('data-value');
        const key = item.getAttribute('data-key');
        this[key] = value;
        console.log(this[key]);
        this.updateMessage(key + ': ' + value);
      });
    });

  },
  methods: {
    updateMessage(value) {

      this.message += value + ` `;
      console.log(this.message);
    },
    validatePhoneNumber(phoneNumber) {
      const phoneRegex = /^(\+\d{1,2})?\d{8,}$/;
      console.log(phoneNumber, phoneRegex.test(phoneNumber));
      return this.phoneValidated = phoneRegex.test(phoneNumber);
    },

    choosePhone(phone) {
      this.phone = phone.formattedNumber;
      this.validatePhoneNumber(phone.formattedNumber);
    },

    async contactFormSend() {

      this.message = 'gender: ' + this.gender + ", age: " + this.age + ", come to istanbul?: " + this.ableToCome + " ";


      if (!(this.validatePhoneNumber(this.phone))) {
        this.$toast.error(this.$i18n.t('contactForm.wrongPhoneFormat'))
        return
      }
      //if there is files selected
      try {
        let fd = new FormData();

        fd.append("name", "Hair banner");
        fd.append("phone", this.phone);
        fd.append("message", this.message);
        fd.append("fullsrc", `https://www.ilajak.com${this.$route.fullPath}`);

        this.$toast.info(this.$t("contactForm.sending"), {
          duration: 100000,
        });

        await this.$api.contactFormSend(fd).then((resp) => {
          if (resp.status === 200 || resp.status === 204) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ event: "form_submitted" });
            // console.log("we are here " + resp.status)

            document.querySelector(`.next-hair-${titleId}`).click();
            this.$toast.success(resp.message);
            this.form.phone = null;
            this.form.message = null;

          }
        });
      } catch (e) {
        // this.$toast.error(e.response.data.message);
      }

      // if no files selected

    }
  },


};
